import axios from 'axios'
import { Message } from 'element-ui'
import { authApiBaseUrl } from '@/config/env'

const authRequest = axios.create({
  baseURL: authApiBaseUrl,
  timeout: 90000
})

authRequest.interceptors.response.use(
  response => response.data,
  error => {
    Message({
      showClose: true,
      type: 'error',
      duration: 0,
      message: error
    })
    return Promise.reject(error)
  }
)

export default authRequest
